module.exports = __webpack_public_path__ + "static/media/UpdatesSocial.be944b5e.jpg";